export const tableOption = {
  border: true,
  index: false,
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  column: [
	  {
      label: 'ID',
      prop: 'id',
      addDisabled: true,
      editDisabled: true,
    },
	  {
      label: '关键词',
      prop: 'keyword',
      search: true,
    },
	  {
      label: '添加日期',
      prop: 'startDate',
      type: 'datetime',
      valueFormat: 'timestamp',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
	  {
      label: '显示天数',
      prop: 'showDays',
      type: 'number'
    },
	  {
      label: '搜索次数',
      prop: 'searchedCount',
      type: 'number',
      sortable: 'custom',
    },
  ]
}
